module.exports = __webpack_public_path__ + "static/banner-9d683b7a0e30d298a64efc3cdc4420bb.svg";